// NOTE: van 生产环境为 prod
export const env =
  process.env.NODE_ENV === 'development'
    ? 'pre'
    : document.documentElement.dataset.vanEnv || 'prod';

export const isProd = env === 'prod';
export const after = isProd ? '' : `-${env}`;
export const DOWNLOADAPI_HOST = {
  stg: 'https://download-api-stg.xiaolachuxing.com',
  pre: 'https://download-api-pre.xiaolachuxing.com',
  prod: 'https://download-api.xiaolachuxing.com',
}[env];
export const API_HOST = {
  stg: 'https://user-stg.xiaolachuxing.com',
  pre: 'https://user-pre.xiaolachuxing.com',
  prod: 'https://user.xiaolachuxing.com',
}[env];

export const EUC_HOST = {
  stg: 'https://euc-stg.xiaolachuxing.com/api',
  pre: 'https://euc-pre.xiaolachuxing.com/api',
  prod: 'https://euc.xiaolachuxing.com/api',
}[env];

export const EUS_HOST = {
  stg: 'https://eus-stg.xiaolachuxing.com/api',
  pre: 'https://eus-pre.xiaolachuxing.com/api',
  prod: 'https://eus.xiaolachuxing.com/api',
}[env];

export const SA_HOST = {
  stg: 'https://uba-stg.xiaolachuxing.com/sa?project=xluser',
  pre: 'https://uba-stg.xiaolachuxing.com/sa?project=xluser',
  prod: 'https://uba.xiaolachuxing.com/sa?project=xluser',
}[env];

// 小拉用户配置服务
export const UCS_HOST = {
  stg: 'https://ucs-user-stg.xiaolachuxing.com/api',
  pre: 'https://ucs-user-pre.xiaolachuxing.com/api',
  prod: 'https://ucs-user.xiaolachuxing.com/api',
}[env];

// 小拉用户信息中心服务
export const UIC_HOST = {
  stg: 'https://uic-user-stg.xiaolachuxing.com/api',
  pre: 'https://uic-user-pre.xiaolachuxing.com/api',
  prod: 'https://uic-user.xiaolachuxing.com/api',
}[env];

export const UPC_HOST = {
  stg: 'https://upc-user-stg.xiaolachuxing.com/api',
  pre: 'https://upc-user-pre.xiaolachuxing.com/api',
  prod: 'https://upc-user.xiaolachuxing.com/api',
}[env];

export const WX_OPEN_JS =
  'https://van-static.xlcx.cn/xl-static/56822/script/jweixin-1.3.2.js';

export const DOUYIN_OPEN_JS =
  'https://van-static.xlcx.cn/xl-static/76039/script/douyin-webview-1.1.0.js';

/** 鸿蒙元服务SDK */
export const HARMONY_META_OPEN_JS =
  'https://van-static.xlcx.cn/xl-static/128709/script/harmony/ascf-web-sdk.umd.js';

export const ALIPAY_OPEN_JS = 'https://appx/web-view.min.js';
